
import mediumZoom from "medium-zoom";

document.addEventListener("turbo:load", function() {
    mediumZoom("img:not([data-zoom-disable])", {
        background: "#333",
    })
})
